import React from "react";
import { ProductsContextProvider } from "../Context/ProductsContext";
import { Box, Flex, Button } from "@chakra-ui/react";
import Header from "../Common/Header";
import ProductsTable from "./ProductsTable";
import ProductsFilter from "./ProductsFilter";
import ContentCard from "../Common/Layout/ContentCard";
import { useHistory } from "react-router-dom";
import Body from "../Common/Body";

const Products = () => {
  const history = useHistory();
  return (
    <ProductsContextProvider>
      <Body title={"Lista de articulos"}>
        <ContentCard>
          <ProductsFilter></ProductsFilter>
        </ContentCard>
        <ContentCard>
          <Button
            my="2"
            colorScheme="blue"
            onClick={() => history.push("/articulos/nuevo")}
          >
            + Artículo
          </Button>
          <ProductsTable></ProductsTable>
        </ContentCard>
      </Body>
    </ProductsContextProvider>
  );
};

export default Products;
